import { ArrowRight } from 'lucide-react';
import type { Service } from '@/types';
import { Button } from '@/components/common/Button';
import { ZoomableImage } from '@/components/common/ImageLightbox';
import { MotionReveal } from '@/components/common/MotionReveal';

interface ServiceSectionProps {
  service: Service;
  index: number;
}

export function ServiceSection({ service, index }: ServiceSectionProps) {
  const reverse = index % 2 === 1;

  return (
    <section
      id={service.id}
      className={`scroll-mt-24 py-18 sm:py-24 lg:py-30 ${reverse ? 'bg-surface-muted' : ''}`}
    >
      <div className="site-container grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
        <MotionReveal className={reverse ? 'lg:order-2' : ''}>
          <ZoomableImage
            className="aspect-[4/3.15] w-full rounded-[var(--radius-md)] object-cover"
            src={service.image}
            alt={service.imageAlt}
            loading="lazy"
          />
        </MotionReveal>

        <MotionReveal delay={0.05} className={reverse ? 'lg:order-1' : ''}>
          <p className="section-label">{service.eyebrow}</p>
          <h2 className="mt-3 text-balance text-3xl font-semibold tracking-[-0.04em] text-text-primary sm:text-4xl">
            {service.title}
          </h2>
          <p className="mt-5 text-base leading-7 text-text-secondary">
            {service.description}
          </p>
          <ul className="mt-7 border-t border-border">
            {service.benefits.map(benefit => (
              <li
                key={benefit}
                className="border-b border-border py-3 text-sm leading-6 text-text-primary"
              >
                {benefit}
              </li>
            ))}
          </ul>
          <Button className="mt-7" to="/kontakt" variant="outline">
            Zatražite ponudu
            <ArrowRight aria-hidden="true" className="size-4" />
          </Button>
        </MotionReveal>
      </div>
    </section>
  );
}
